import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { News } from '../../shared/interface';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-notizia',
  templateUrl: './notizia.component.html',
  styleUrl: './notizia.component.css',
  encapsulation: ViewEncapsulation.None
})
export class NotiziaComponent implements OnInit {

  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router) { }

  notizia?: News;
  notizie: News[] = [];

  ngOnInit(): void {

    // Recupero i parametri passati nell'url
    this.route.params.subscribe(params => {

      // Recupero l'url della news
      const url = params['url'];

      //Recupero i dati della notizia
      this.apiService.getNotiziaUrl(url).subscribe({
        next: (data) => this.notizia = data,
        error: (err) => this.router.navigate(['/news']),
        complete: () => {
          this.apiService.getNotizie().subscribe({
            next: (data) => this.notizie = [...this.sortNews(data).filter(notizia => notizia.id != this.notizia?.id).slice(0, 3)],
            error: (err) => this.router.navigate(['/news']),
            complete: () => { }
          })
        },
      })
    })

  }

  sortNews(notizie: News[]): News[] {
    for (let i = notizie.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [notizie[i], notizie[j]] = [notizie[j], notizie[i]];
    }
    return notizie;
  }

}